// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.paddingLeft {
  padding-left: 10px;
}

.flexCenter {
  justify-content: center;
  align-items: center;
  display: flex;
}

.edit {
  cursor: pointer;
}

.noDataFound {
  text-align: center;
  padding: 15px 0;
  font-weight: 500;
  font-size: 20px;
}

@media screen and (max-width: 599px) {
  .mat-table {
    border: 0;
    vertical-align: middle;
  }
  .mat-table caption {
    font-size: 1em;
  }
  .mat-table .mat-row {
    border-bottom: 5px solid #ddd;
    display: block;
  }
  .mat-table .mat-cell {
    border-bottom: 1px solid #ddd;
    display: block;
    font-size: 1em;
    text-align: right;
    margin-bottom: 4%;
    padding: 15px 15px;
  }
  .mat-header-cell {
    font-weight: bold;
  }
  .mat-table .mat-cell:before {
    content: attr(data-label);
    float: left;
    text-transform: uppercase;
    font-weight: normal;
    font-size: 0.85em;
  }
  .mat-table .mat-cell:last-child {
    border-bottom: 0;
  }
  .mat-table .mat-cell:first-child {
    margin-top: 4%;
  }
  mat-header-row.mat-header-row.cdk-header-row.ng-star-inserted {
    display: none;
  }
}
mat-header-cell {
  text-transform: capitalize;
}

mat-cell,
mat-header-cell,
mat-footer-cell {
  text-align: center;
  margin: auto;
  display: grid;
  word-break: break-word;
  border-right: 1px solid #d4d4d4;
  margin: 0;
}

mat-header-cell {
  border-top: 1px solid #d4d4d4;
  padding-top: 2px;
}

mat-row {
  align-items: stretch;
}

.mat-header-cell {
  color: #000000;
  font-size: 16px;
}

[data-label="charge codes"] {
  padding-bottom: 5px;
}

mat-cell:first-of-type,
mat-header-cell:first-of-type,
mat-footer-cell:first-of-type {
  padding-left: 5px;
  border-left: 1px solid #d4d4d4;
}

mat-cell:last-of-type,
mat-header-cell:last-of-type,
mat-footer-cell:last-of-type {
  padding-right: 0px;
}

mat-header-cell.mat-header-cell.cdk-header-cell.cdk-column-select.mat-column-select.ng-star-inserted {
  visibility: visible;
}

[data-label="GST [%]"],
[data-label="created on"],
[data-label="import date"],
[data-label="approved / rejected on"],
[data-label="exported on"],
[data-label=type] {
  white-space: pre-wrap;
}

/*pnrReport{
    margin-bottom: 50px;
    text-align: center;
}*/`, "",{"version":3,"sources":["webpack://./src/app/components/table/table.component.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;AACJ;;AAEA;EACI,uBAAA;EACA,mBAAA;EACA,aAAA;AACJ;;AAEA;EACI,eAAA;AACJ;;AAEA;EACI,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;AACJ;;AAEA;EACI;IACI,SAAA;IACA,sBAAA;EACN;EACE;IACI,cAAA;EACN;EACE;IACI,6BAAA;IACA,cAAA;EACN;EACE;IACI,6BAAA;IACA,cAAA;IACA,cAAA;IACA,iBAAA;IACA,iBAAA;IACA,kBAAA;EACN;EACE;IACI,iBAAA;EACN;EACE;IACI,yBAAA;IACA,WAAA;IACA,yBAAA;IACA,mBAAA;IACA,iBAAA;EACN;EACE;IACI,gBAAA;EACN;EACE;IACI,cAAA;EACN;EACE;IACI,aAAA;EACN;AACF;AAEA;EACI,0BAAA;AAAJ;;AAcA;;;EAGI,kBAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,+BAAA;EACA,SAAA;AAXJ;;AAcA;EACI,6BAAA;EACA,gBAAA;AAXJ;;AAcA;EACI,oBAAA;AAXJ;;AAiBA;EACI,cAAA;EACA,eAAA;AAdJ;;AAiBA;EACI,mBAAA;AAdJ;;AAiBA;;;EAGG,iBAAA;EACA,8BAAA;AAdH;;AAgBA;;;EAGI,kBAAA;AAbJ;;AAgBA;EACK,mBAAA;AAbL;;AAsBA;;;;;;EAMI,qBAAA;AAnBJ;;AAuBA;;;EAAA","sourcesContent":[".paddingLeft {\n    padding-left: 10px;\n}\n\n.flexCenter {\n    justify-content: center;\n    align-items: center;\n    display: flex;\n}\n\n.edit {\n    cursor: pointer;\n}\n\n.noDataFound {\n    text-align: center;\n    padding: 15px 0;\n    font-weight: 500;\n    font-size: 20px;\n}\n\n@media screen and (max-width: 599px) {\n    .mat-table {\n        border: 0;\n        vertical-align: middle\n    }\n    .mat-table caption {\n        font-size: 1em;\n    }\n    .mat-table .mat-row {\n        border-bottom: 5px solid #ddd;\n        display: block;\n    }\n    .mat-table .mat-cell {\n        border-bottom: 1px solid #ddd;\n        display: block;\n        font-size: 1em;\n        text-align: right;\n        margin-bottom: 4%;\n        padding: 15px 15px;\n    }\n    .mat-header-cell {\n        font-weight: bold;\n    }\n    .mat-table .mat-cell:before {\n        content: attr(data-label);\n        float: left;\n        text-transform: uppercase;\n        font-weight: normal;\n        font-size: .85em;\n    }\n    .mat-table .mat-cell:last-child {\n        border-bottom: 0;\n    }\n    .mat-table .mat-cell:first-child {\n        margin-top: 4%;\n    }\n    mat-header-row.mat-header-row.cdk-header-row.ng-star-inserted {\n        display: none;\n    }\n}\n\nmat-header-cell {\n    text-transform: capitalize;\n}\n\n// mat-header-cell,\n// mat-footer-cell,\n// mat-cell {\n//     text-align: left;\n//     vertical-align: top;\n//     margin: auto;\n//     display: grid;\n//     place-items: center;\n//     word-break: break-word;\n// }\n\nmat-cell,\nmat-header-cell,\nmat-footer-cell{\n    text-align: center;\n    margin: auto;\n    display: grid;\n    word-break: break-word;\n    border-right: 1px solid #d4d4d4;\n    margin: 0;\n}\n\nmat-header-cell{\n    border-top: 1px solid #d4d4d4;\n    padding-top: 2px;\n}\n\nmat-row{\n    align-items: stretch;\n}\n\n// [data-label=\"\"]{\n//   white-space: pre-wrap\n// }\n.mat-header-cell {\n    color: #000000;\n    font-size: 16px;\n}\n\n[data-label=\"charge codes\"] {\n    padding-bottom: 5px;\n}\n\nmat-cell:first-of-type,\nmat-header-cell:first-of-type,\nmat-footer-cell:first-of-type {\n   padding-left: 5px;\n   border-left: 1px solid #d4d4d4;\n}\nmat-cell:last-of-type,\nmat-header-cell:last-of-type,\nmat-footer-cell:last-of-type {\n    padding-right: 0px;\n}\n\nmat-header-cell.mat-header-cell.cdk-header-cell.cdk-column-select.mat-column-select.ng-star-inserted {\n     visibility: visible;\n}\n\n// mat-cell.mat-cell.cdk-cell.ng-star-inserted\n// mat-header-cell.mat-cell.cdk-cell.ng-star-inserted\n// mat-footer-cell.mat-cell.cdk-cell.ng-star-inserted{\n//     border-right: 1px solid #d4d4d4;\n// }\n\n[data-label=\"GST [%]\"],\n[data-label=\"created on\"],\n[data-label=\"import date\"],\n[data-label=\"approved / rejected on\"],\n[data-label=\"exported on\"],\n[data-label=\"type\"] {\n    white-space: pre-wrap;\n}\n\n\n/*pnrReport{\n    margin-bottom: 50px;\n    text-align: center;\n}*/\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
